import { useEffect, useRef } from 'react';
import { useAuth } from './AuthContext';
import { trackEvent } from './analytics';

const HEARTBEAT_INTERVAL = 5 * 60 * 1000; // 5 minutes

export function HeartbeatTracker() {
  const { user } = useAuth();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!user) {
      // Clear interval if user logs out
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }

    // Send initial heartbeat on mount
    trackEvent({ event_name: 'heartbeat' });

    // Set up recurring heartbeat
    intervalRef.current = setInterval(() => {
      trackEvent({ event_name: 'heartbeat' });
    }, HEARTBEAT_INTERVAL);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [user]);

  return null;
}
